import { render, staticRenderFns } from "./IndicatorMenu.vue?vue&type=template&id=4bb9ac7e&scoped=true"
import script from "./IndicatorMenu.vue?vue&type=script&lang=js"
export * from "./IndicatorMenu.vue?vue&type=script&lang=js"
import style0 from "./IndicatorMenu.vue?vue&type=style&index=0&id=4bb9ac7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb9ac7e",
  null
  
)

export default component.exports